
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/image-to-flashcards",
      function () {
        return require("private-next-pages/image-to-flashcards.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/image-to-flashcards"])
      });
    }
  